import React from 'react'

export const Grid = ({
  children, mediumColumns, className, halfSplit, dashboard, metrics, jointPlan,
  ...passThroughProps
}) => {
  const base = 'grid'
  const modifiers =
    (mediumColumns ? `${base}--medium-columns ` : '') +
    (halfSplit ? `${base}--half-split ` : '') +
    (dashboard ? `${base}--dashboard ` : '') +
    (metrics ? `${base}--metrics ` : '') +
    (jointPlan ? `${base}--joint-plan `: '')

  const additionalClassNames = className || ''
  return (
    <div className={`grid ${modifiers}${additionalClassNames}`} {...passThroughProps}>
      {children}
    </div>
  )
}
